/** This component is an example of using composition to customize a component
 *  It is a combination of a few different Material UI components that can
 *  be exported and used many times across the app
 */
import React from "react";
import { TextField, TextFieldProps, Typography, Grid } from "@material-ui/core";

const BigLabelTextField: React.FC<TextFieldProps> = props => {
  // Remove the label from the props we pass down to the text field
  const fieldProps = { ...props, label: undefined, placeholder: undefined };

  return (
    <Grid container direction="column">
      <Grid item>
        <Typography gutterBottom variant="h6">
          {props.label}
        </Typography>
      </Grid>
      <Grid item>
        <TextField
          {...fieldProps}
          defaultValue={props.placeholder}
          disabled={true}
        />
      </Grid>
    </Grid>
  );
};

export default BigLabelTextField;
